
  function refresh_btn(show){
    if(show){
      // $('img.refresh-btn-img').click(function(){
        var end='webkitAnimationEnd msanimationend oanimationend animationend';
        $('.refresh-btn-img').addClass('btn-ger-round');
        $('.refresh-btn-img').one(end,function(){
          $(this).removeClass('btn-ger-round');
        });
      // });
    } else {
      $('.refresh-btn-img').removeClass('btn-ger-round');
    }
  }
  
  export {refresh_btn}
  


// WEBPACK FOOTER //
// ./src/components/beautiful-chat/js/refresh_btn.js